/**
 * Throttle: ensure a given action key can only fire once per second.
 * Prevents double-submit (e.g. double-click or duplicate listeners).
 */
const THROTTLE_MS = 1000;
const lastCallByKey = Object.create(null);

function throttle(key, fn) {
  return function throttled(...args) {
    const now = Date.now();
    const last = lastCallByKey[key] || 0;
    if (now - last < THROTTLE_MS) return;
    lastCallByKey[key] = now;
    return fn.apply(this, args);
  };
}

/**
 * Campaign Onboarding - Button wiring (runs when Stimulus controller connects).
 * Reads config from the container's data attributes (Turbo-safe).
 */
export function runInit(configEl) {
  console.log(
    "[campaign-onboarding] runInit called, configEl:",
    configEl,
    "dataset:",
    configEl?.dataset ? Object.keys(configEl.dataset) : "none",
  );

  if (!configEl?.dataset) {
    console.log(
      "[campaign-onboarding] runInit bailing: no configEl or dataset",
    );
    return;
  }

  const CampaignOnboarding = globalThis.CampaignOnboarding;
  const STEPS = CampaignOnboarding?.STEPS;
  if (!CampaignOnboarding || !STEPS) {
    console.log(
      "[campaign-onboarding] runInit bailing: CampaignOnboarding or STEPS missing",
      { hasCO: !!CampaignOnboarding, hasSTEPS: !!STEPS },
    );
    return;
  }

  const d = configEl.dataset;
  if (document.body?.dataset) {
    Object.keys(d).forEach(function (key) {
      document.body.dataset[key] = d[key];
    });
  }

  const debugModeAvailable = d.debugMode === "true";
  console.log(
    "[campaign-onboarding] debugMode raw:",
    d.debugMode,
    "debugModeAvailable:",
    debugModeAvailable,
    "urlStatus:",
    !!d.urlStatus,
    "urlRunAll:",
    !!d.urlRunAll,
    "urlFetchOperations:",
    !!d.urlFetchOperations,
  );

  const urls = {
    status: d.urlStatus,
    "run-all": d.urlRunAll,
  };

  if (debugModeAvailable) {
    urls["create-demo"] = d.urlCreateDemo;
    urls["fetch-operations"] = d.urlFetchOperations;
    urls["select-operation"] = d.urlSelectOperation;
    urls["initiate"] = d.urlInitiate;
    urls["start-sync"] = d.urlStartSync;
    urls["check-payload"] = d.urlCheckPayload;
    urls["create-campaign"] = d.urlCreateCampaign;
    urls["import-accounts"] = d.urlImportAccounts;
    urls["import-transactions"] = d.urlImportTransactions;
    urls["complete-onboarding"] = d.urlComplete;
    urls["confirm-sync"] = d.urlConfirmSync;
    urls["fetch-confirm-payload"] = d.urlFetchConfirmPayload;

    Object.keys(STEPS).forEach(function (stepId) {
      const btn = document.getElementById(stepId + "-btn");
      if (btn) {
        btn.addEventListener(
          "click",
          throttle(stepId, function () {
            const url = urls[stepId];
            if (url) {
              CampaignOnboarding.handleStep(stepId, url, STEPS[stepId].method);
            } else {
              console.error("No URL configured for step:", stepId);
            }
          }),
        );
      }
    });

    const fetchOpsBtn = document.getElementById("fetch-operations-btn");
    if (fetchOpsBtn) {
      fetchOpsBtn.addEventListener(
        "click",
        throttle("fetch-operations", function () {
          console.log("[campaign-onboarding] Fetch operations clicked");
          CampaignOnboarding.handleFetchOperations(urls);
        }),
      );
      console.log(
        "[campaign-onboarding] attached listener to fetch-operations-btn",
      );
    } else {
      console.log(
        "[campaign-onboarding] fetch-operations-btn not found in DOM",
      );
    }
  } else {
    console.log(
      "[campaign-onboarding] debug mode not available, skipping step/fetch-operations buttons",
    );
  }

  const runAllBtn = document.getElementById("run-all-steps-btn");
  if (runAllBtn) {
    runAllBtn.addEventListener(
      "click",
      throttle("run-all", function () {
        console.log("[campaign-onboarding] Run all clicked");
        CampaignOnboarding.runAllSteps(urls);
      }),
    );
    console.log("[campaign-onboarding] attached listener to run-all-steps-btn");
  } else {
    console.log("[campaign-onboarding] run-all-steps-btn not found in DOM");
  }
  console.log("[campaign-onboarding] runInit done");
}
